import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'

// css
import './index.css'
import './chart.css'
import './step.css'

// Layout
import Nav from './layouts/nav'
import Footer from './layouts/Footer'

// Dashboard  
import Home from './components/Dashboard/Home'

// User Management
import UserList from './pages/UserManagement/UserList';
import AddUser from './pages/UserManagement/AddUser';
import EditUser from './pages/UserManagement/EditUser';
import UserPurchasedTickets from './pages/UserManagement/UserPurchasedTickets';
import UserResaleTickets from './pages/UserManagement/UserResaleTickets';
import OrganizersUserList from './pages/UserManagement/OrganizersUsers';

// Events Management
import EventsList from './pages/EventsManagement/EventsList';
import AddEvent from './pages/EventsManagement/AddEvent';
import EventDetails from './pages/EventsManagement/EventDetails';
import EditEvent from './pages/EventsManagement/EditEvent';

// Venues Management
import VenueList from './pages/VenueManagement/VenueList';
import AddVenue from './pages/VenueManagement/AddVenue';
import EditVenue from './pages/VenueManagement/EditVenue';
import VenueDetails from './pages/VenueManagement/VenueDetails';
import SeatCategories from './pages/VenueManagement/SeatCategories';

// Transaction
import Transaction from './pages/Transaction/index';
import PrimaryMarketTransactions from './pages/Transaction/PrimaryMarket';
import SecondaryMarketTransactions from './pages/Transaction/SecondaryMarket';
import OrganizersTransactions from './pages/Transaction/Organizers';
import WithdrawalTransactions from './pages/Transaction/WithdrawalTransactions';


// Organizer Management
import OrganizerList from './pages/Organizer/OrganizerList';
import AddOrganizer from './pages/Organizer/AddOrganizer';
import EditOrganizer from './pages/Organizer/EditOrganizer';

// CMS Page Management
import CMSPagesList from './pages/CMSPages/CMSPagesList';
import CMSPagesEdit from './pages/CMSPages/CMSPagesEdit';

// Settings
import GeneralSettings from './pages/Settings/GeneralSettings';
import SemSettings from './pages/Settings/SemSettings';
import ResellSettings from './pages/Settings/ResellSettings';
import AdminProfile from './pages/AdminProfile/AdminProfile';
import ChangePassword from './pages/AdminProfile/ChangePassword';

// Need to Remove this 

/// Charts
import ChartJs from './components/Dashboard/Chartjs'
import SparklineChart from './components/Dashboard/Sparkline'

//ResaleMarket
import ListedTicket from './pages/ResaleMarket/ListedTicket';
import SoldTicket from './pages/ResaleMarket/SoldTicket';

// Settings
import OrgTicket from './pages/OrgTicket/index';

import Poster from './pages/Poster/index';

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: '', component: <Home /> },
    { url: 'dashboard', component: <Home /> },

    /// Chart
    { url: 'chart-sparkline', component: <SparklineChart /> },
    { url: 'chart-chartjs', component: <ChartJs /> },

    // User Management
    { url: 'user-list', component: <UserList /> },
    { url: 'user-add', component: <AddUser /> },
    { url: 'user-edit/:u_id', component: <EditUser /> },
    { url: 'user-purchase-tickets/:u_id', component: <UserPurchasedTickets /> },
    { url: 'user-resale-tickets/:u_id', component: <UserResaleTickets /> },
    { url: 'organizers-user-list', component: <OrganizersUserList /> },


    // Events Management
    { url: 'events-list', component: <EventsList /> },
    { url: 'event-add', component: <AddEvent /> },
    { url: 'event-details/:e_id', component: <EventDetails /> },
    { url: 'event-edit/:e_id', component: <EditEvent /> },

    // Venues Management
    { url: 'venue-list', component: <VenueList /> },
    { url: 'venue-add', component: <AddVenue /> },
    { url: 'venue-details/:v_id', component: <VenueDetails /> },
    { url: 'venue-edit/:v_id', component: <EditVenue /> },
    { url: 'venue-seat-categories/:v_id', component: <SeatCategories /> },

    // Transaction
    { url: 'transaction', component: <Transaction /> },
    { url: 'primary-market-transaction', component: <PrimaryMarketTransactions /> },
    { url: 'secondary-market-transaction', component: <SecondaryMarketTransactions /> },
    { url: 'organizers-transaction', component: <OrganizersTransactions /> },
    { url: 'withdrawal-transaction', component: <WithdrawalTransactions /> },

    // Organizer Management
    { url: 'organizer-list', component: <OrganizerList /> },
    { url: 'organizer-add', component: <AddOrganizer /> },
    { url: 'organizer-edit/:o_id', component: <EditOrganizer /> },

    // CMS Page Management
    { url: 'cms-page-list', component: <CMSPagesList /> },
    { url: 'cms-page-edit/:page_slug', component: <CMSPagesEdit /> },

    // Settings 
    { url: 'general-settings', component: <GeneralSettings /> },
    { url: 'sem-settings', component: <SemSettings /> },
    { url: 'resell-settings', component: <ResellSettings /> },
    { url: 'admin-profile', component: <AdminProfile /> },
    { url: 'change-password', component: <ChangePassword /> },

    //Resale Market
    { url: 'listed-tickets', component: <ListedTicket /> },
    { url: 'sold-tickets', component: <SoldTicket /> },

    //Org Ticket
    { url: 'org-tickets', component: <OrgTicket /> },

    //Poster
    { url: 'poster', component: <Poster /> },
  ]

  return (
    <>
      <Routes>
        <Route element={<MainLayout />} > 
          {allroutes.map((data, i) => (
            <Route key={i} exact path={`${data.url}`} element={data.component} />
          ))}
        </Route>
      </Routes>
    </>
  )
}

function MainLayout() {
  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 230 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  )
};

export default Markup
